import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import Nl2br from 'vue-nl2br';
var QuestTabs = function QuestTabs() {
  return import('@/components/organisms/QuestTabs');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
export default {
  components: {
    Nl2br: Nl2br,
    QuestTabs: QuestTabs,
    PageTitle: PageTitle
  },
  data: function data() {
    return {
      isLoading: false
    };
  },
  computed: {
    raid: function raid() {
      return useRaidStore().getRaid;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    getCurrentFgData: function getCurrentFgData() {
      return useFrontierGateStore().getCurrentFgData;
    },
    isNormalQuest: function isNormalQuest() {
      return this.getQuestType == useQuestStore().getQuestTypes.normalQuest;
    },
    isLandQuest: function isLandQuest() {
      return this.getQuestType == useQuestStore().getQuestTypes.landQuest;
    },
    isCooperationQuest: function isCooperationQuest() {
      return this.getQuestType == useQuestStore().getQuestTypes.cooperationQuest;
    },
    isEventQuest: function isEventQuest() {
      return this.getQuestType == useQuestStore().getQuestTypes.eventQuest;
    },
    getQuestType: function getQuestType() {
      if (this.$route.name.includes('event')) {
        return useQuestStore().getQuestTypes.eventQuest;
      } else if (this.$route.query.landQuest) {
        return useQuestStore().getQuestTypes.landQuest;
      } else {
        return useQuestStore().getQuestTypes.normalQuest;
      }
    },
    getSince: function getSince() {
      var index = this.getCurrentFgDataIndex;
      if (index === -1) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var since = new Date(this.getCurrentFgData[index].eventPeriod.since * 1000).toLocaleString(locale, options);
      return since;
    },
    getUntil: function getUntil() {
      var index = this.getCurrentFgDataIndex;
      if (index === -1) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.getCurrentFgData[index].eventPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    },
    getRaidSince: function getRaidSince() {
      if (!Object.keys(this.raid).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var since = new Date(this.raid.raidTypeMaster.eventPeriod.since * 1000).toLocaleString(locale, options);
      return since;
    },
    getRaidUntil: function getRaidUntil() {
      if (!Object.keys(this.raid).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.raid.raidTypeMaster.eventPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    },
    now: function now() {
      return this.$dayjs();
    },
    getCurrentFgDataIndex: function getCurrentFgDataIndex() {
      return useFrontierGateStore().getCurrentFgDataIndex;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.isLoggedIn) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _this.isLoading = true;
            _context.next = 5;
            return useFrontierGateStore().fetchCurrentFrontierGate();
          case 5:
            _this.isLoading = false;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    }
  }
};